import { type FormBuilder, type FormControl, Validators } from '@angular/forms';
import { type CurrencyCodeType } from '@bizzdesign/sdk-knowledgegraph';
import { type ObjectType } from '@bizzdesign/sdk-knowledgegraph/bdcore';
import { generateUUID } from '@bizzdesign/bizzdesign-sdk/uuid';
import { type AttributeType } from '@bizzdesign/shared/models';
import { type TreeNode } from 'primeng/api';

export class AttributeDefinitionForm {
  name: FormControl<string | null>;
  id: FormControl<string | null>;
  type: FormControl<AttributeType | null | undefined>;
  currency: FormControl<CurrencyCodeType | null | undefined>;
  enumValues: FormControl<string[] | null>;
  referenceType: FormControl<TreeNode<ObjectType> | null | undefined>;

  constructor(fb: FormBuilder) {
    this.name = fb.control<string>('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(30),
    ]);
    this.id = fb.control<string>(generateUUID(), [Validators.required]);
    this.type = fb.control<AttributeType | undefined>(
      undefined,
      Validators.required,
    );
    this.currency = fb.control<CurrencyCodeType | undefined>({
      value: undefined,
      disabled: true,
    });
    this.enumValues = fb.control<string[]>({ value: [], disabled: true });
    this.referenceType = fb.control<TreeNode<ObjectType> | undefined>({
      value: undefined,
      disabled: true,
    });
    this.type.valueChanges.subscribe((selectedType) => {
      this.currency.reset(undefined);
      this.currency.disable();
      this.currency.clearValidators();

      this.enumValues.reset([]);
      this.enumValues.disable();
      this.enumValues.clearValidators();

      this.referenceType.reset(undefined);
      this.referenceType.disable();
      this.referenceType.clearValidators();

      if (selectedType === 'money') {
        this.currency.setValidators([Validators.required]);
        this.currency.enable();
      } else if (selectedType === 'enum') {
        this.enumValues.setValidators([Validators.required]);
        this.enumValues.enable();
      } else if (selectedType === 'reference') {
        this.referenceType.setValidators([Validators.required]);
        this.referenceType.enable();
      }
    });
  }
}
